import { SELECTED_LANGUAGE } from 'app/constants/AppConstants';
import { getCinemaLangsOptions } from 'app/selectors/AppSelectors';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Select from "tochkak-ui/lib/Select"

function LanguageSelector() {
	const langOptions = useSelector(getCinemaLangsOptions)

	const [currentLang, setCurrentLang] = useState(SELECTED_LANGUAGE);

	const handleLangChange = (_, selectedValue) => {
		setCurrentLang(selectedValue);
		i18n.changeLanguage(selectedValue);
		localStorage.setItem('lang', selectedValue);
		window.location.reload();
	}

	if (langOptions.length < 2) return null;

	return (
		<div className="header__select-button header__change_lang-button">
			<Select
				options={langOptions}
				onSelect={handleLangChange}
				selectedOptionValue={currentLang}
				buttonText={i18n.t('ChooseLang')}
			/>
		</div>
	);
}

export default LanguageSelector;
